

const initialState = {
    count: 0,
    isAuthenticated: false,
    sidebarExpanded: false,
    user:{},
    store:{
        "id": 2,
        "store_id": "Ad0GvuHxtKbHcCWw",
        "store_title": "\u0935\u0940\u0930 \u092c\u0939\u093e\u0926\u0941\u0930 \u0938\u093f\u0902\u0939 \u0930\u093e\u091c\u0915\u0940\u092f \u092e\u0939\u093e\u0935\u093f\u0926\u094d\u092f\u093e\u0932\u092f \u0915\u092e\u094d\u092a\u093f\u092f\u0930\u0917\u0902\u091c \u0917\u094b\u0930\u0916\u092a\u0941\u0930 = Veer Bahadur Singh Rajkeeya Mahavidyalaya Campierganj Gorakhpur",
        "short_name": null,
        "store_description": "\u091c\u094d\u091e\u093e\u0928 \u090f\u0935\u0902 \u0930\u094b\u091c\u0917\u093e\u0930\u094b\u0928\u094d\u092e\u0941\u0916 \u0936\u093f\u0915\u094d\u0937\u093e \u0939\u0947\u0924\u0941 \u0938\u092e\u0930\u094d\u092a\u093f\u0924 \u0938\u0902\u0938\u094d\u0925\u093e\u0928",
        "store_logo": "1739516941vbsnewlogoremovebgpreview.png",
        "store_fav_logo": "1739516941vbsnewlogoremovebgpreview.png",
        "store_address": "Campierganj, Gorakhpur\r\nUttar Pradesh PIN 273158",
        "store_phone": "+91 8896756818",
        "store_email": "collegewebsitevbsgdc@gmail.com",
        "marquee": "Samarth eGov Student Portal",
        "principal_image": "principal.jpg",
        "principal_message": "प्रो. (डॉ.) रमेश चंद्र वर्मा मानव जीवन को विकसित करने के लिए शिक्षा ही एक ऐसा माध्यम है जिसके द्वारा देश अपने हजारों साल की संस्कृति को संजोकर एवं भविष्य में दुनिया के विकसित देशो के साथ कदम से कदम मिला कर चल सकेगा। 21वीं शताब्दी में मानव, विज्ञान एवं प्रौद्योगिकी द्वारा ऐसी क्रांति लायेगा जो कल्पना से परे होगा और मानव का दायरा इस संसार तक ही सीमित न रहकर बाह्य जगत से जुड़ेगा। हमारा संकल्प है कि हम अपने विद्यार्थियों को ऐसी गुणवत्तापरक एवं राजगारोन्मुखी शिक्षा प्रदान करेंगे जो उन्हें आर्थिक रूप से सक्षम एवं स्वावलंबी बनाने के साथ ही साथ एक सच्चे भारतीय नागरिक के गुणों से सुसज्जित हो सके। यह संस्थान अपने उत्तम शैक्षणिक आधारभूत संरचना और सर्वश्रेष्ठ नवोन्मेषी संकायों के द्वारा छात्रों के ज्ञानोपार्जन, अनुशासन व चरित्र निर्माण में सतत संलग्न है। हमारा विश्वास है कि हमारे अध्यापक, छात्र एवं छात्राएं राष्ट्र-निर्माण के महायज्ञ में कदम से कदम मिलाकर आगे बढ़ते रहेंगे और अपने देश को अपने समय में ही एक विकसित देश के रूप में देख सकेंगे। मेरी शुभकामनाएं !",
        "principal_name": "loading..",
        "store_status": "1",
        "created_at": "2024-07-29 08:03:52",
        "updated_at": "2025-02-14 07:11:49",
        "store_theme_id": 1,
        "affiliation_info": "Affiliated to Deen Dayal Upadhyay Gorakhpur University, Gorakhpur",
        "about_page": "<p>उच्च शिक्षा के प्रसार के संकल्प को साकार करने के उद्देश्य से उत्तर प्रदेश सरकार द्वारा प्रदेश के सुदूर एवं पिछड़े क्षेत्रों में राजकीय महाविद्यालयों की स्थापना के क्रम में पनियरा क्षेत्र के स्थानीय विधायक एवं उ.प्र. शासन के तत्कालीन राज्यमंत्री (स्वतंत्र प्रभार), माननीय फतेह बहादुर सिंह के अथक प्रयास से शासनादेश संख्या: शि.मं./29/सत्तर-5-99-40(59)/95 दिनांक 28 अप्रैल, 1999 द्वारा राजकीय महाविद्यालय कम्पियरगंज, गोरखपुर की स्थापना हुई। स्वतंत्रता प्राप्ति के पचास वर्ष बाद भी इस ग्रामीणांचल के छात्र-छात्राओं को उच्च शिक्षा प्राप्त करने के लिए दूर-दराज के महाविद्यालयों में जाना पड़ता था, जिससे अभिभावकों और छात्र-छा़त्राओं को बहुत कठिनाई होती थी। फलतः इस क्षेत्र के विकास हेतु सतत जागरूक माननीय फतेह बहादुर सिंह के अथक परिश्रम से यह राजकीय महाविद्यालय अस्तित्व में आया। <\/p> ",
        "about_image": "https:\/\/campus.acetians.in\/custom\/images\/about_img2.jpg",
        "social_link": "#",
        "facilities": []
    },
    sliders:['https://campus.acetians.in/custom/image/lalitpur-logo.png'],
    notices:[],
    gallery_images:[],
    courses:[],
    staffs:[],
    link:[],
};

const rootReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOGIN':
            return { ...state, isAuthenticated: true };
        case 'EXPAND':
            return { ...state, sidebarExpanded: true };
        case 'COMPRESS':
            return { ...state, sidebarExpanded: false };
        case 'SET_STORE_DATA':
            return {...state,store:action.payload};
        case 'SET_STORE_SLIDERS':
                return {...state,sliders:action.payload};
        case 'SET_NOTICES':
                return {...state,notices:action.payload};
        case 'SET_STAFFS':
                return {...state,staffs:action.payload};
        case 'SET_GALLERY_IMAGES':
                return {...state,gallery_images:action.payload};
        case 'SET_COURSE_DATA':
                return {...state,courses:action.payload};
        case 'SET_LINK':
                return {...state,link:action.payload};
        default: 
            return state;
    }
};

export default rootReducer;
